import React from 'react';
import { UserPlus, Search, Heart, MessageCircle } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const steps = [
  {
    id: 'step-create',
    number: '01',
    icon: UserPlus,
    title: 'Create Your Profile',
    description: 'Share your Kenyan background, US location, faith, relationship intention, and what makes you uniquely you. Your profile is your first impression.',
  },
  {
    id: 'step-browse',
    number: '02',
    icon: Search,
    title: 'Discover & Browse',
    description: 'Filter by Kenyan county, US state, relationship intention, faith, and age. Find Kenyan singles who match your values and vision.',
  },
  {
    id: 'step-connect',
    number: '03',
    icon: Heart,
    title: 'Like & Match',
    description: 'Like profiles that catch your interest. When someone likes you back, it becomes a mutual match — your signal to take the next step.',
  },
  {
    id: 'step-message',
    number: '04',
    icon: MessageCircle,
    title: 'Message & Build',
    description: 'Premium members can send and read messages. Start real conversations, build genuine connections, and let relationships unfold naturally.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-surface">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 2xl:px-16">
        <div className="text-center mb-16 space-y-3">
          <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-primary mb-2">
            Simple Process
          </div>
          <h2 className="section-header">How JSN Works</h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            From profile to meaningful connection — designed for serious Kenyan diaspora singles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {steps?.map((step, idx) => {
            const Icon = step?.icon;
            return (
              <div
                key={step?.id}
                className="relative bg-card border border-border rounded-2xl p-6 card-hover group"
              >
                {/* Connector line */}
                {idx < steps?.length - 1 && (
                  <div className="hidden xl:block absolute top-10 -right-3 w-6 h-0.5 bg-border z-10" />
                )}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                      <Icon size={22} className="text-primary" />
                    </div>
                    <span className="text-4xl font-black text-border group-hover:text-primary/20 transition-colors">
                      {step?.number}
                    </span>
                  </div>

                  <div>
                    <h3 className="font-semibold text-lg text-foreground mb-2">{step?.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{step?.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}